module.exports = __webpack_public_path__ + "img/about-us.ce6da168.png";